import { useCallback } from "react";
import {
  RegisterOptions,
  useController,
  Control,
  FieldValues,
  Path,
} from "react-hook-form";
import DateInput from "@components/new/DateInput";

interface DateInputContainerProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>;
  name: Path<TFieldValues>;
  rules?: Omit<
    RegisterOptions<TFieldValues>,
    "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
  >;
  title: string;
  placeholder?: string;
  disabled?: boolean;
  onChange?: (v: string | Date | undefined) => void;
  disabledBefore?: Date;
  disabledAfter?: Date;
}

const DateInputContainer = <TFieldValues extends FieldValues = FieldValues>(
  props: DateInputContainerProps<TFieldValues>,
) => {
  const { field, fieldState } = useController<TFieldValues>({
    control: props.control,
    name: props.name,
    rules: props.rules,
  });

  const handleOnChange = useCallback((v: Date | undefined) => {
    return props.onChange
      ? field.onChange(props.onChange(v))
      : field.onChange(v);
  }, [props.onChange]);

  return (
    <DateInput
      title={props.title}
      value={field.value}
      onChange={handleOnChange}
      placeholder={props.placeholder}
      errorMessage={fieldState.error?.message}
      hasError={!!fieldState.error}
      disabled={props.disabled}
      disabledBefore={props.disabledBefore}
      disabledAfter={props.disabledAfter}
    />
  );
};

export default DateInputContainer;
